import React from 'react';

import { render } from 'react-dom';

import './assets/fonts/vazirmatn-variable.woff2';
import './i18n/i18n.config';
import './index.css';
import { App } from './app';

render(<App />, document.getElementById('app'));
